var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4233b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34cd4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ab441"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df2239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc162c"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.060952 -.335238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.061133.333207h16v11.428571h-16z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 .33320737 6.85714286 5.71428571-6.85714286 5.71428572z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2038096.33320737 6.8571429 5.71428571-6.8571429 5.71428572z",
    fill: "url(#d)",
    transform: "matrix(-1 0 0 1 25.264762 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.36850796 3.98677955c-2.41536231-1.62701105-4.22251976-2.84486845-5.42147235-3.65357218l-.88608323.01440538v1.23566701c1.20949797.81581667 3.02779857 2.03795799 5.4549018 3.66642395-.07887546.25190172-.12138735.51988095-.12138735.79778937s.04251189.54588766.12138735.79778938c-2.42399087 1.63500248-4.24198401 2.86125434-5.45397945 3.67875554v1.2397715l.89291465-.0040036c1.20304857-.8114665 3.00762143-2.02866627 5.41371858-3.65159927.46042895.37862644 1.04997974.60595314 1.69262553.60595314s1.23219657-.2273267 1.69262552-.60595314c2.40721569 1.62368746 4.21262749 2.84145307 5.41623529 3.65329677l.8915189-.0016975v-1.2350118c-1.2122445-.81766922-3.0306113-2.04417311-5.4551004-3.67951164.0788754-.25190172.1213874-.51988096.1213874-.79778938s-.042512-.54588765-.1213874-.79778937c2.4223544-1.63389865 4.2391201-2.85932264 5.4502973-3.67627196v-1.23666071h-.8915909c-1.2025245.811113-3.0063112 2.02778251-5.41136019 3.65000851-.46042895-.37862648-1.04997973-.60595313-1.69262552-.60595313s-1.23219658.22732665-1.69262553.60595313z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.06113349 5.28558832-.53874804.15779564.15779565-.53874802-.15779565-.53874802.53874804.15779564.53874803-.15779564-.15779565.53874802.15779565.53874802zm-1.14285715 1.90476193-.53874804.15779565.15779566-.53874806-.15779566-.53874802.53874804.15779564.53874804-.15779564-.15779566.53874802.15779566.53874806zm2.28571429 0-.53874804.15779565.15779566-.53874806-.15779566-.53874802.53874804.15779564.53874804-.15779564-.15779566.53874802.15779566.53874806z",
    fill: "url(#e)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.d68aaf8b4dc6e9ba75a071848c1a3a71.svg";
export { ForwardRef as ReactComponent };